import { Component, EventEmitter, inject, Input, Output, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserService } from '../../../core/services/user.service';
import { ButtonComponent } from '../../../shared-with-client/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { InvoiceStatus, ISaleStatus } from '../../../core/services/invoicing.service';
import { StoresService } from '../../../core/services/stores.service';
import { CancelInvoiceModalComponent } from '../cancel-invoice-modal/cancel-invoice-modal.component';
import { Dialog } from '@angular/cdk/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sale-detail-actions',
  imports: [ButtonComponent, TranslatePipe],
  templateUrl: './sale-detail-actions.component.html',
  styleUrl: './sale-detail-actions.component.scss',
})
export class SaleDetailActionsComponent {

  @Input() sale: any;
  @Output() saleUpdated = new EventEmitter<any>();
  @Output() closeParent = new EventEmitter<void>();
  @Output() destroyPreview = new EventEmitter<void>();

  ISaleStatus = ISaleStatus;
  InvoiceStatus = InvoiceStatus;

  private userService = inject(UserService);
  public currentUser: Signal<any> = toSignal(this.userService.currentUser);
  private storesService = inject(StoresService);
  public currentStore: Signal<any> = toSignal(this.storesService.getActiveStore());
  public isInvoicingActive = toSignal(this.storesService.isInvoicingActive());
  
  private modalService = inject(Dialog);
  private router = inject(Router);

  addPayment(): void {
      this.close();
      const id = this.sale.id;
      this.destroyPreview.emit();
      this.router.navigateByUrl(`${this.currentStore().slug}/dashboard/payment/pay/${id}`);
  }

  editSale(): void {
      this.close();
      const id = this.sale.id;
      this.destroyPreview.emit();
      this.router.navigateByUrl(`${this.currentStore().slug}/dashboard/payment/edit/${id}`);
  }

  createFullInvoice(): void {
      this.close();
      const id = this.sale.id;
      this.destroyPreview.emit();
      this.router.navigateByUrl(`${this.currentStore().slug}/dashboard/payment/complete/${id}`);
  }

  cancelInvoice(): void {
      const confirmDialogRef = this.modalService.open(CancelInvoiceModalComponent, {
          data: {
              saleId: this.sale.id,
              saleStatus: this.sale.status,
              hasPayments: this.sale?.salePayments?.length > 0,
          },
      });
      confirmDialogRef.closed.subscribe((res: any) => {
          if (res === 'yes') {
            this.updateSaleDetails();
          }
      });
  }

  // sendPaymentLink(): void {
  //     // this.modalService.open(EmailInvoiceModalComponent, { data: { merchantClientId: this.sale.merchantClientId, saleId: this.sale.id, pdfUrl: this.sale.invoicePdfUrl } });
  // }

  close(): void {
      this.closeParent.emit();
  }

  updateSaleDetails(): void {
    this.saleUpdated.emit();
  }

}
